import styled from "styled-components";
import IconMenuCloseWhite from "../Assets/images/icon-set-close-white.svg";
import IconMenuOpenWhite from "../Assets/images/icon-set-menu-white.svg";
import {
  default as LogoImg,
  default as LogoImgWhite,
} from "../Assets/images/VESTN_FullLogo-Sand.png";
import IconMenuClose from "../Assets/images/white-cross.svg";
import NotifiIconWhite from "../svg/LandingPageImages/Notification.svg";
import Media from "../Theme/media-breackpoint";
// import NotifiIcon from "../Assets/images/notification.svg";

interface HeadMBXProps {
  scrolled?: boolean;
}

const BrandName = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: hsl(var(--foreground));
  letter-spacing: 0.1em;
  text-shadow: 0 2px 8px rgba(255, 255, 255, 0.15);
  ${Media.sm} {
    font-size: 18px;
  }
`;

const LogoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

/**
 * Logo Box Component
 * Styled container for the "V" logo with gradient background
 */
const LogoBox = styled.div`
  width: 120px;
  height: 70px;
  // background: linear-gradient(
  //     120deg,
  //     rgba(193, 225, 35, 1),
  //     rgba(0, 92, 83, 1)
  // );
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  font-weight: 800;
  font-size: 28px;
  color: hsl(var(--foreground));
  font-family: "Inter", sans-serif;
  ${Media.sm} {
    width: 32px;
    height: 32px;
    font-size: 18px;
    margin-right: 8px;
  }
`;

const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const HeadMBX = styled(FlexDiv)<HeadMBXProps>`
  width: 100%;
  min-height: 100px;
  position: fixed;
  z-index: 100;
  background: ${({ scrolled }) =>
    scrolled ? "rgba(12, 28, 45, 0.9)" : "rgba(12, 28, 45, 0.7)"};
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);

  box-shadow: ${({ scrolled }) =>
    scrolled
      ? "0 4px 24px rgba(116, 142, 25, 0.25), 0 8px 32px rgba(0, 0, 0, 0.3), 0 1px 0 rgba(255, 255, 255, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.05)"
      : "none"};

  ${Media.md} {
    min-height: 70px;
  }
  &.gradient-header {
    background-color: transparent;
    box-shadow: none;
    .RWA-logo {
      background: url(${LogoImgWhite}) no-repeat;
      background-size: contain;
    }
    .desktop-menu a {
      color: hsl(var(--foreground));
      :hover {
        :after {
          background-color: hsl(var(--background));
        }
      }

      .active {
        :after {
          background-color: #bae325;
        }
      }
    }
    .ph-bg {
      background-color: transparent;
      span {
        color: hsl(var(--foreground));
        span {
          color: rgb(255 255 255 / 30%);
        }
      }
    }
    .menu-active {
      background: url(${IconMenuCloseWhite}) no-repeat;
    }
    .menu-deactive {
      background: url(${IconMenuOpenWhite}) no-repeat;
    }
    .noti-button-outer {
      ${Media.md} {
        background-color: transparent;
      }
      .Notifi-Icon {
        ${Media.md} {
          background: url(${NotifiIconWhite}) no-repeat;
        }
      }
    }
  }
`;
const HeadMBX02 = styled(FlexDiv)`
  // width: 100%;
  // max-width: 1240px;
  margin: 0 auto;
  ${Media.lg} {
    margin: 0 15px;
    justify-content: flex-start;
  }
`;

const MobileMenu = styled(FlexDiv)`
  display: none;
  @media (max-width: 1024px) {
    display: flex;
    position: absolute;
    right: 15px;
  }
`;

const MobileSidebar = styled.div`
  background-color: hsl(var(--background));
  width: 100%;
  position: absolute;
  top: 70px;
  left: 0px;
  display: none;
  @media (max-width: 1024px) {
    display: block;
  }
  .collapse-active#mobile-block {
    height: auto !important;
  }
`;

const HeadSbx01 = styled(FlexDiv)`
  justify-content: flex-start;
  padding: 0 15px;
  &.mobile-logo {
    ${Media.md} {
      // width: 50px;
    }
  }
  &.desktop-menu,
  .desktop-menu {
    @media (max-width: 1024px) {
      display: none;
    }
  }

  ${Media.lg} {
    width: 28.33%;
  }
  &:nth-child(2) {
    justify-content: center;
    a {
      color: hsl(var(--foreground));
      font-size: 16px;
      font-weight: 400;
      padding: 0 10px;
      line-height: 20px;
      position: relative;
      font-family: "Inter", sans-serif;
      ${Media.lg} {
        font-size: 13px;
        padding: 0 12px;
      }
      :hover,
      &.active {
        color: hsl(var(--primary));
        :after {
          // content: "";
          left: 0;
          width: 100%;
          right: 20px;
          height: 2px;
          border-radius: 50%;
          transform: scaleX(0);
          transition: transform 0.25s ease-out;
          transform-origin: bottom right;
          background-color: #bae325;
          display: block;
          position: absolute;
          bottom: -3px;
        }
        :hover:after {
          transform: scaleX(1);
          transform-origin: bottom left;
        }
      }
      &.active:after {
        transform: scaleX(1);
        transform-origin: bottom left;
      }
    }
    ${Media.lg} {
      width: 50.33%;
    }
  }
  &:nth-child(3) {
    justify-content: flex-end;
    ${Media.lg} {
      width: 25.33%;
    }
  }
`;
const Logo = styled(FlexDiv)`
  .RWA-logo {
    background: url(${LogoImg}) no-repeat;
    background-size: contain;
    width: 150px;
    height: 58px;
    ${Media.md} {
      width: 100px;
      height: 37px;
    }
  }
`;

const AvBTN01 = styled.button`
  padding: 9px 40px;
  color: hsl(var(--primary));
  // background: linear-gradient(130.35deg, #ff0000 17.35%, #8b0000 78.23%);
  background: transparent;
  border: 1px solid hsl(var(--primary));
  border-radius: 12px;
  transition: all 0.3s ease;
  :hover {
    background-color: hsl(var(--primary));
    color: hsl(var(--primary-foreground));
    -webkit-box-shadow: 0 4px 12px hsl(var(--primary) / 0.3);
    box-shadow: 0 4px 12px hsl(var(--primary) / 0.3);
  }
`;

const LanBTN = styled(FlexDiv)`
  margin-left: 30px;
  position: relative;
  button {
    font-size: 12px;
    font-weight: 600;
    color: hsl(var(--primary-foreground));
  }
`;
const AvBTN02 = styled.button`
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 600;
  color: hsl(var(--primary-foreground));
  background-color: hsl(var(--primary));
  border-radius: 12px;
  min-width: 100px;
  max-width: 130px;
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s ease;
  border: none;
  :hover {
    background-color: hsl(var(--primary) / 0.9);
    -webkit-box-shadow: 0 4px 12px hsl(var(--primary) / 0.3);
    box-shadow: 0 4px 12px hsl(var(--primary) / 0.3);
    transform: translateY(-1px);
  }
  :active {
    transform: translateY(0);
  }

  &.grayBTN {
    background-color: hsl(var(--muted));
    color: hsl(var(--muted-foreground));
    min-width: 100px;
    max-width: 130px;
    min-height: 40px;
    padding: 0 16px;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap !important;
    overflow: hidden;
    text-overflow: ellipsis;
    border: 1px solid hsl(var(--border));
    transition: all 0.3s ease;
    :hover {
      background-color: hsl(var(--muted) / 0.8);
      border-color: hsl(var(--primary) / 0.5);
      color: hsl(var(--foreground));
    }
  }
  &.colorBTN {
    font-family: "Inter", sans-serif !important;
    font-size: 14px;
    font-weight: 700;
    border-radius: 12px !important;
    min-width: 100px;
    max-width: 130px;
    min-height: 40px;
    padding: 0 16px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap !important;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: hsl(var(--primary));
    color: hsl(var(--primary-foreground));
    box-shadow: 0 4px 16px hsl(var(--primary) / 0.25);
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.3),
        transparent
      );
      transition: left 0.5s;
    }

    &:hover::before {
      left: 100%;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px hsl(var(--primary) / 0.35);
      background: hsl(var(--primary) / 0.95);
      color: hsl(var(--primary-foreground));
    }

    :active {
      transform: translateY(0);
    }

    svg {
      transition: transform 0.3s ease;
    }

    &:hover svg {
      transform: translateX(4px);
    }

    @media (max-width: 768px) {
      padding: 0 36px;
      font-size: 18px;
      min-width: 180px;
      min-height: 56px;
    }

    @media (max-width: 480px) {
      padding: 0 32px;
      font-size: 16px;
      min-width: 160px;
      min-height: 52px;
    }
  }
`;

const NotificationBX = styled(FlexDiv)`
  margin-left: 8px;
  position: relative;
  .Notifi-Icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & > button {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 15px;
    &.noti-button-outer {
      padding: 0px;
    }
    &.active,
    :hover {
      // border: 1px solid #d6dde5;
      -webkit-box-shadow: 1px 8px 10px 1px rgba(0, 0, 0, 0.08);
      // box-shadow: 1px 8px 10px 1px rgba(0, 0, 0, 0.08);
      // border: 1px solid #eef2f7;
      // background-color: #ffffff;
      color: hsl(var(--primary));
      span.RedDot {
        display: block;
      }
    }
    span.RedDot {
      width: 12px;
      height: 12px;
      border-radius: 8px;
      display: block;
      position: absolute;
      right: -2px;
      top: -2px;
      background-color: #bae325;
      display: none;
      // :hover{
      //   background-color: #fff;
      // }
    }
  }
`;
const AccountBX = styled(FlexDiv)`
  margin-left: 30px;
  position: relative;
  border: solid 1px transparent;
  width: 210px;
  justify-content: flex-end;
  // background-color: #bae325;
  border: 1px solid #bae325;
  color: hsl(var(--primary));
  padding: 8px 10px;
  border-radius: 15px;
  z-index: 100;
  cursor: pointer;
  ${Media.lg} {
    padding: 8px 10px;
  }
  &:hover {
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px hsl(var(--primary));
  }

  & i {
    width: 50px;
    height: 50px;
    border-radius: 30px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  & span {
    font-size: 14px;
    font-weight: 600;
    color: hsl(var(--primary));
    display: block;
    text-align: right;
    line-height: 16px;
    padding-right: 8px;
    span {
      font-size: 10px;
      color: hsl(var(--primary));
      width: 100%;
      padding-right: 0;
    }
  }
`;
const DDContainer = styled(FlexDiv)`
  position: absolute;
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  background: linear-gradient(180deg, #0c1c2d 0%, #081420 100%);
  padding: 15px;
  border-radius: 14px !important;
  border: 1px solid #bae325;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.3);
  top: calc(100% + 30px);
  width: 200px;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
  z-index: 100;
  &.ver2 {
    width: 300px;
    left: auto;
    transform: translateX(0);
    right: 0;
    top: calc(100% + 20px);
    padding: 0;
    // border-radius: 15px;
  }
  &.ver3 {
    width: 300px;
    left: 50%;
    transform: translateX(-50%);
    top: calc(100% + 34px);
    padding: 0;
    ${Media.md} {
      transform: none;
      left: auto;
      right: -49px;
      width: 100vw;
      top: calc(100% + 21px);
      box-shadow: none;
      border-radius: 0px;
      justify-content: flex-start;
    }
  }
  #disconnect {
    color: #fff !important;
  }
  #view_your_profile {
    color: #fff !important;
  }
`;
const DDBtnbar01 = styled(FlexDiv)`
  font-size: 16px;
  color: hsl(var(--muted-foreground));
  font-weight: 600;
  button {
    font-size: 16px;
    padding: 0 10px;
    margin: 0 6px;
    color: hsl(var(--muted-foreground));
    &.active {
      color: hsl(var(--primary-foreground));
    }
    :hover {
      color: hsl(var(--primary-foreground));
    }
  }
`;
const DDBtnbar02 = styled(FlexDiv)`
  width: 100%;
  button {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 58px;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid #eef2f7;
    padding: 0 20px;
    transition: all 0.3s ease;

    & i {
      width: 34px;
      height: 34px;
      margin-right: 12px;
      overflow: hidden;
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    & span {
      margin-left: auto;
      display: flex;
      align-items: center;
      img {
        width: 16px;
        height: 16px;
      }
    }

    &:nth-last-child(1) {
      border-bottom: 0px;
    }

    &:hover {
      background-color: #bae325;
      color: #1e293b !important;
    }
    &:hover *,
    &:hover svg {
      color: #1e293b !important;
    }
    &.text-destructive:hover,
    &.text-destructive:hover *,
    &.text-destructive:hover svg {
      color: hsl(var(--destructive)) !important;
    }
  }
`;

const ABC = styled(FlexDiv)`
  align-items: flex-start;
  justify-content: flex-start;
`;

const CloseBTN = styled.button`
  width: 20px;
  height: 20px;
  // position: absolute;
  // right: 20px;
  // top: 27px;
  padding: 0;
  margin: 0px;
  :hover {
    transform: rotate(90deg);
  }
  ${Media.xs} {
    right: 15px;
    top: 15px;
  }
`;

const Bars = styled.div`
  color: hsl(var(--primary-foreground));
  font-size: 20px;
  margin-left: 10px;
  background: url(${IconMenuOpenWhite}) no-repeat;
  width: 24px;
  height: 24px;
  &.menu-active {
    background: url(${IconMenuClose}) no-repeat;
  }
`;

const MobInner = styled.div`
  width: 100%;
  padding: 20px 20px;
  .mobile-links {
    a {
      width: max-content;
      display: block;
      font-size: 16px;
      padding: 0px 0px 16px !important;
      :after {
        left: 0px !important;
        bottom: 14px !important;
        width: 100%;
        height: 2px !important;
      }
    }
    :hover {
      a:not(:hover) {
        opacity: 0.3;
      }
    }
  }
  .mobile-login-btn {
    margin-top: 60px;
    text-align: center;
    button {
      // padding: 12px 75px 15px;
      // width: 200px;
      height: 45px;
      font-size: 16px;
      text-transform: capitalize;
    }
    a {
      :after {
        display: none !important;
      }
    }
  }
`;

const FooterrightLinks = styled(FlexDiv)`
  margin: 20px 0px 30px;
  a {
    font-size: 13px !important;
    letter-spacing: -0.6px !important;
    font-weight: 500 !important;
    :last-child {
      margin-right: 0px;
    }
  }
`;

const Mobiledisconnect = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px auto;
  font-size: 16px;
  font-weight: 600;
  background-color: transparent;
  color: hsl(var(--primary));
  border: 1px solid #bae325 !important;
  padding: 12px 30px;
  // border-radius: 15px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 212px;
  text-decoration: none;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(186, 227, 37, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const Moremenu = styled(FlexDiv)`
  .more-parts {
    width: 50%;
    a {
      font-size: 14px;
      letter-spacing: -0.62px;
      font-weight: 600;
      display: block;
      margin-bottom: 15px;
      :after {
        display: none !important;
      }
    }
  }
  :hover {
    a:not(:hover) {
      opacity: 0.3;
    }
  }
`;
const BlackWrap = styled(FlexDiv)`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(11, 34, 44, 0.8),
    rgba(0, 0, 0, 0.9)
  );
  z-index: 101;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
`;
const WhiteBX01 = styled(FlexDiv)`
  width: 100%;
  position: relative;
  max-width: 400px;
  margin: 0 15px;
  min-height: 418px;
  padding: 50px;
  border-radius: 30px;
  justify-content: center;
  align-content: center;
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3),
    inset 0 0 0 1px rgba(255, 255, 255, 0.1);
  color: #ffffff;
  ${Media.xs} {
    padding: 50px 25px;
  }
  form {
    width: 100%;
    // .view{
    //   width:100%;
    //   overflow-x:hidden !important;
    //   overflow-y:auto !important;
    // }
  }
`;
const WGTitle = styled.div`
  color: hsl(var(--foreground));
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  letter-spacing: -0.6px;
  margin-bottom: 20px;
  text-align: center;
  width: 100%;
`;
const DesktopLogin = styled.div`
  display: block;
`;

export {
  ABC,
  AccountBX,
  AvBTN01,
  AvBTN02,
  Bars,
  BlackWrap,
  BrandName,
  CloseBTN,
  DDBtnbar01,
  DDBtnbar02,
  DDContainer,
  DesktopLogin,
  FlexDiv,
  FooterrightLinks,
  HeadMBX,
  HeadMBX02,
  HeadSbx01,
  LanBTN,
  Logo,
  LogoBox,
  LogoRow,
  Mobiledisconnect,
  MobileMenu,
  MobileSidebar,
  MobInner,
  Moremenu,
  NotificationBX,
  WGTitle,
  WhiteBX01,
};
